import { useEffect, useRef, useState } from 'react';
import { GET, GET_PRODUCT_FULL_SEARCH } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { exactClaimBarcodeProducts } from '../../../../functions/claimProductBarcode';

export const useBarcodeQuery = ({ setValue, getValues }) => {
  const state = useRef({
    version: 0,
    touched: false,
    loading: false,
    options: [],
    barcode: '',
    selected: '',
  });
  const [, render] = useState(0);
  const refresh = () => render((value) => value + 1);
  const fill = (product) => {
    setValue('productId', product?.productId || '');
    setValue('productName', product?.productName || '');
    setValue('productTypeName', product?.productTypeName || '');
    state.current.selected = product?.productId || '';
  };
  const invalidate = () => {
    const current = state.current;
    current.version += 1;
    current.touched = true;
    current.loading = false;
    current.options = [];
    fill();
    refresh();
  };
  useEffect(
    () => () => {
      state.current.version += 1;
    },
    [],
  );

  const onBarcodeChange = (event) => {
    const value = event.target.value;
    if (value !== getValues().barcodeShortcut) invalidate();
    // InputSearch spreads this callback over its controller callback.
    setValue('barcodeShortcut', value, { shouldDirty: true });
  };
  const mutate = async (value) => {
    invalidate();
    const barcode = String(value || '');
    setValue('barcodeShortcut', barcode);
    const current = state.current;
    current.barcode = barcode;
    const version = current.version;
    const isCurrent = () =>
      version === state.current.version && getValues().barcodeShortcut === barcode;
    if (!/^[0-9]{9}$/.test(barcode)) {
      openAlert({ type: 'error', model: 'message', message: 'กรุณาระบุบาร์โค้ด 9 หลัก' });
      return;
    }
    current.loading = true;
    refresh();
    try {
      const response = await GET(GET_PRODUCT_FULL_SEARCH({ search: `8859${barcode}` }));
      if (!isCurrent()) return;
      current.options = exactClaimBarcodeProducts(response?.result?.items, barcode);
      if (current.options.length === 1) fill(current.options[0]);
      if (!current.options.length) {
        openAlert({ type: 'error', model: 'message', message: 'ไม่พบสินค้าที่ตรงกับบาร์โค้ดนี้' });
      }
    } catch (error) {
      if (!isCurrent()) return;
      fill();
      openAlert({ type: 'error', model: 'message', message: 'ค้นหาสินค้าไม่สำเร็จ กรุณาลองใหม่' });
    } finally {
      if (isCurrent()) {
        current.loading = false;
        refresh();
      }
    }
  };
  const onSelectProduct = (productId) => {
    const current = state.current;
    const product =
      !current.loading && current.barcode === getValues().barcodeShortcut
        ? current.options.find((item) => item.productId === productId)
        : undefined;
    fill(product);
  };
  const canSubmit = (values) => {
    const current = state.current;
    if (!current.touched) return true;
    return (
      !current.loading &&
      current.barcode === getValues().barcodeShortcut &&
      !!current.selected &&
      current.selected === getValues().productId &&
      current.selected === values.productId &&
      current.barcode === values.barcodeShortcut
    );
  };
  return {
    mutate,
    onBarcodeChange,
    onSelectProduct,
    canSubmit,
    productOptions: state.current.options,
    loading: state.current.loading,
  };
};
